import { render, staticRenderFns } from "./GroupActivities.vue?vue&type=template&id=ced59f4e&scoped=true"
import script from "./GroupActivities.vue?vue&type=script&lang=js"
export * from "./GroupActivities.vue?vue&type=script&lang=js"
import style0 from "./GroupActivities.vue?vue&type=style&index=0&id=ced59f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced59f4e",
  null
  
)

export default component.exports